module.exports = "/* You can add global styles to this file, and also import other style files */\n/*@import \"../node_modules/bootstrap/scss/_buttons\";*/\n.esc-link-active {\n\tcolor: #fff;\n\tborder-bottom: 3px solid #fcb238;\n}\n.link-nav {\n\tcolor: #fff;\n\tfont-size: 16px;\n}\n.nav-item {\n\tcolor: #fff;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles/styles.css
// module chunks = styles